import { BlockMapping } from './interfaces'
import { Group } from './Group'
import { Picture } from './Picture'
import { Text } from './Text'
import { Icon } from './Icon'
import { Button } from './Button'
import { FormField } from './FormField'
import { Input } from './Input'
import { TextArea } from './TextArea'
import { RadioGroup } from './RadioGroup'
import { CheckboxGroup } from './CheckboxGroup'
import { Flag } from './Flag'
import { HiddenInput } from './HiddenInput'
import { Select } from './Select'
import { Rating } from './Rating'
import { Image } from './Image'
import { BlockType } from '@gsc/types'

export const DEFAULT_BLOCK_MAPPING: BlockMapping = {
  [BlockType.Text]: Text,
  [BlockType.Icon]: Icon,
  [BlockType.Group]: Group,
  [BlockType.Picture]: Picture,
  [BlockType.Button]: Button,
  [BlockType.FormField]: FormField,
  [BlockType.Input]: Input,
  [BlockType.Textarea]: TextArea,
  [BlockType.RadioGroup]: RadioGroup,
  [BlockType.CheckboxGroup]: CheckboxGroup,
  [BlockType.Flag]: Flag,
  [BlockType.Hidden]: HiddenInput,
  [BlockType.Select]: Select,
  [BlockType.Rating]: Rating,
  [BlockType.Image]: Image,
}
